import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function GuidesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
          {t('guides.title')}
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600">{t('guides.subtitle')}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-all hover:border-primary-300 cursor-pointer"
          >
            <div className="relative h-44 md:h-48 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                title={`${article.title} AllChinaBuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-3 left-3 rounded-full bg-background-50/90 backdrop-blur px-3 py-1 text-xs font-semibold text-primary-700 whitespace-nowrap">
                Guide
              </span>
            </div>
            <div className="flex flex-col flex-1 p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                {article.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{article.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 whitespace-nowrap">
                {t('guides.readMore')}
                <span className="flex w-4 h-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}